import { IsNotEmpty, IsOptional, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { AddressDto } from "../common";
import { ICourseDogOwnerInfo } from "./course-dog-owner-info.interface";

export class CourseDogOwnerInfoDto
  implements Omit<ICourseDogOwnerInfo, "owner_id">
{
  @IsNotEmpty()
  display_name: string;

  @IsNotEmpty()
  email: string;

  @IsOptional()
  phone?: string;

  @IsOptional()
  @ValidateNested()
  @Type(() => AddressDto)
  address?: AddressDto;

  // junior support
  @IsOptional()
  is_junior?: boolean;

  @IsOptional()
  parent_name?: string;

  @IsOptional()
  junior_dob?: Date;

  @IsOptional()
  junior_number?: string;
}
